<template>
  <div id="app" >
    
    <router-view/>
    </div>
</template>

<script>
// import MainPage from "@/MainPage";
// import Login from "@/views/Login";



export default {
  name: 'App',
      components: {
      // MainPage,
      // Login,
      // GlobalLoading,
    },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    }
  },
}
</script>

<style lang="scss">
@import "~@/assets/scss/theme";
@import "~@/assets/scss/custom";
@import "~@/assets/scss/icon.scss";
html,body{
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100vh;
  width: 100vw;
}
</style>
